import * as Yup from "yup";

export const formSchema = Yup.object().shape({
    // Krok 1 - dane pojazdu
    tradein_brand: Yup.string()
        .required('Marka samochodu jest wymagana.')
        .min(2, 'Marka jest za krótka.')
        .max(50, 'Marka jest za długa.'),
    tradein_model: Yup.string()
        .required('Model samochodu jest wymagany.')
        .min(1, 'Model jest za krótki.')
        .max(50, 'Model jest za długi.'),
    vin: Yup.string()
        .required('Numer VIN jest wymagany.')
        .min(17, 'Numer VIN musi mieć 17 znaków.')
        .max(17, 'Numer VIN musi mieć 17 znaków.')
        .matches(/^[A-Z0-9]{17}$/, 'Podaj prawidłowy numer VIN (17 znaków).'),
    tradein_first_registration_date: Yup.date()
        .required('Data pierwszej rejestracji jest wymagana.')
        .max(new Date(), 'Data nie może być z przyszłości.'),
    tradein_mileage: Yup.string()
        .required('Przebieg pojazdu jest wymagany.'),
    tradein_registration_number: Yup.string()
        .required('Numer rejestracyjny jest wymagany.')
        .min(2, 'Numer rejestracyjny jest za krótki.')
        .max(10, 'Numer rejestracyjny jest za długi.')
        .matches(/^[A-Z0-9\s-]+$/, 'Podaj prawidłowy numer rejestracyjny.'),
    tradein_description: Yup.string()
        .max(500, 'Opis jest za długi (maksymalnie 500 znaków).'),
    voivodeship: Yup.string(),
    dealer_id: Yup.string()
        .required('Wybierz punkt z listy.'),
    
    // Krok 2 - dane kontaktowe
    name: Yup.string()
        .required('Imię i nazwisko jest wymagane.')
        .min(2, 'Imię i nazwisko jest za krótkie.')
        .max(100, 'Imię i nazwisko jest za długie.')
        .matches(/^[\p{L} ]+$/gu, 'Podaj prawidłowe imię i nazwisko.'),
    phone: Yup.string()
        .matches(/^[+]?[0-9\s-()]{9,15}$/, 'Podaj prawidłowy numer telefonu.')
        .required('Numer telefonu jest wymagany.'),
    email: Yup.string()
        .email('Podaj prawidłowy adres email.')
        .required('Email jest wymagany.')
        .max(100, 'Email jest za długi.')
});
